import styled from 'styled-components';
import SwimmingIconSvg from '../../assets/hotels/amenities/swimming-pool.svg';

const SwimmingIcon = styled(SwimmingIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.2rem'};
  height: ${props => props.height || '1.2rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default SwimmingIcon;
